import React, { ReactNode, createContext, useContext, useEffect, useState } from 'react';
// import logger from '../../../../logger';

interface AppContextType {
	contextData: any;
	setContextData: React.Dispatch<React.SetStateAction<any>>;
}

interface ProviderProps {
	initialValues?: any;
	children: ReactNode;
}

const AppContext = createContext<AppContextType | undefined>(undefined);

export const AppContextProvider: React.FC<ProviderProps> = ({ initialValues = {}, children }) => {
	const [contextData, setContextData] = useState<any>();

	useEffect(() => setContextData(initialValues), [initialValues]);

	return <AppContext.Provider value={{ contextData, setContextData }}>{children}</AppContext.Provider>;
};

export const useAppContext = (): AppContextType => {
	const context = useContext(AppContext);

	if (!context) {
		// logger.error('useAppContext must be used within a AppContextProvider', { error: context, at: new Error })
		throw new Error('useAppContext must be used within a AppContextProvider');
	}

	return context;
};
